export const featuredComics = [
  {
    id: 'feat-1',
    title: '剑与魔法',
    subtitle: 'Sword & Magic',
    category: '奇幻冒险',
    rating: 9.6,
    description: '少年剑士踏上拯救王国的旅程，觉醒远古力量',
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20fantasy%20comic%20cover%20art%2C%20young%20swordsman%20with%20glowing%20blue%20sword%20in%20dark%20forest%2C%20epic%20atmosphere%2C%20manga%20style%20illustration%20with%20dramatic%20lighting%2C%20clean%20background%2C%20professional%20comic%20cover%20design&width=600&height=800&seq=comic-feat-01&orientation=portrait',
  },
  {
    id: 'feat-2',
    title: '甜蜜陷阱',
    subtitle: 'Sweet Trap',
    category: '恋爱言情',
    rating: 9.3,
    description: '办公室恋情悄然展开，她的秘密让他无法自拔',
    image: 'https://readdy.ai/api/search-image?query=Korean%20romance%20manhwa%20cover%20art%2C%20beautiful%20couple%20in%20modern%20office%20setting%2C%20soft%20pink%20and%20warm%20tones%2C%20romantic%20atmosphere%2C%20manga%20style%20illustration%2C%20clean%20simple%20background%2C%20professional%20comic%20cover&width=600&height=800&seq=comic-feat-02&orientation=portrait',
  },
  {
    id: 'feat-3',
    title: '暗夜行者',
    subtitle: 'Night Walker',
    category: '悬疑惊悚',
    rating: 9.5,
    description: '夜晚的城市隐藏着不为人知的秘密，他独自追寻真相',
    image: 'https://readdy.ai/api/search-image?query=Korean%20thriller%20manhwa%20cover%20art%2C%20mysterious%20detective%20in%20dark%20rainy%20city%20alley%2C%20noir%20atmosphere%20with%20neon%20accents%2C%20dramatic%20shadows%2C%20manga%20style%20illustration%2C%20clean%20background%2C%20professional%20comic%20cover&width=600&height=800&seq=comic-feat-03&orientation=portrait',
  },
];

export const heroStats = {
  totalComics: 12860,
  dailyUpdates: 86,
  activeReaders: 325000,
};

export const latestComics = [
  {
    id: 'latest-1',
    title: '重生之商业帝国',
    category: '都市职场',
    chapter: '第128话',
    updateTime: '2小时前',
    image: 'https://readdy.ai/api/search-image?query=Korean%20business%20manhwa%20cover%20art%2C%20handsome%20businessman%20in%20luxury%20office%20with%20city%20skyline%20view%2C%20modern%20professional%20style%2C%20clean%20minimalist%20background%2C%20manga%20illustration%2C%20warm%20lighting&width=500&height=667&seq=comic-latest-01&orientation=portrait',
  },
  {
    id: 'latest-2',
    title: '武林至尊',
    category: '武侠动作',
    chapter: '第256话',
    updateTime: '5小时前',
    image: 'https://readdy.ai/api/search-image?query=Korean%20martial%20arts%20manhwa%20cover%20art%2C%20warrior%20in%20traditional%20clothing%20on%20mountain%20peak%20with%20misty%20background%2C%20epic%20atmosphere%2C%20dynamic%20pose%2C%20manga%20illustration%2C%20clean%20simple%20background&width=500&height=667&seq=comic-latest-02&orientation=portrait',
  },
  {
    id: 'latest-3',
    title: '异世界食堂',
    category: '美食治愈',
    chapter: '第89话',
    updateTime: '8小时前',
    image: 'https://readdy.ai/api/search-image?query=Korean%20food%20manhwa%20cover%20art%2C%20cozy%20restaurant%20interior%20with%20delicious%20dishes%20on%20table%2C%20warm%20inviting%20atmosphere%2C%20soft%20lighting%2C%20manga%20illustration%2C%20clean%20simple%20background&width=500&height=667&seq=comic-latest-03&orientation=portrait',
  },
  {
    id: 'latest-4',
    title: '星界旅人',
    category: '科幻未来',
    chapter: '第67话',
    updateTime: '12小时前',
    image: 'https://readdy.ai/api/search-image?query=Korean%20sci-fi%20manhwa%20cover%20art%2C%20space%20explorer%20in%20futuristic%20suit%20with%20stars%20and%20nebula%20background%2C%20cosmic%20atmosphere%2C%20manga%20illustration%2C%20clean%20simple%20background%2C%20professional%20comic%20cover&width=500&height=667&seq=comic-latest-04&orientation=portrait',
  },
  {
    id: 'latest-5',
    title: '校园日记',
    category: '青春校园',
    chapter: '第198话',
    updateTime: '1天前',
    image: 'https://readdy.ai/api/search-image?query=Korean%20school%20life%20manhwa%20cover%20art%2C%20students%20in%20school%20uniform%20under%20cherry%20blossom%20trees%2C%20bright%20spring%20atmosphere%2C%20youthful%20vibrant%20style%2C%20manga%20illustration%2C%20clean%20simple%20background&width=500&height=667&seq=comic-latest-05&orientation=portrait',
  },
  {
    id: 'latest-6',
    title: '魔王转生',
    category: '奇幻冒险',
    chapter: '第312话',
    updateTime: '1天前',
    image: 'https://readdy.ai/api/search-image?query=Korean%20dark%20fantasy%20manhwa%20cover%20art%2C%20demon%20lord%20character%20with%20dark%20cape%20and%20glowing%20eyes%2C%20gothic%20castle%20background%2C%20dramatic%20lighting%2C%20manga%20illustration%2C%20clean%20simple%20background&width=500&height=667&seq=comic-latest-06&orientation=portrait',
  },
];

export const testimonials = [
  {
    id: 'test-1',
    name: '漫画迷小七',
    role: '资深读者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20girl%20avatar%20portrait%2C%20cute%20young%20woman%20with%20long%20dark%20hair%2C%20friendly%20smile%2C%20simple%20warm%20tone%20background%2C%20clean%20illustration%20style&width=120&height=120&seq=avatar-test-01&orientation=squarish',
    content: '韩漫吧是我用过最好用的漫画阅读平台！资源超全，更新速度也快，最重要的是完全免费。每天睡前都要刷几话才能安心入睡。',
    rating: 5,
  },
  {
    id: 'test-2',
    name: '夜雨声烦',
    role: '漫画博主',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20boy%20avatar%20portrait%2C%20cool%20young%20man%20with%20glasses%2C%20thoughtful%20expression%2C%20simple%20warm%20tone%20background%2C%20clean%20illustration%20style&width=120&height=120&seq=avatar-test-02&orientation=squarish',
    content: '作为一个漫画博主，我推荐过很多平台，但韩漫吧的阅读体验确实一骑绝尘。下拉式阅读太流畅了，翻译质量也很高。',
    rating: 5,
  },
  {
    id: 'test-3',
    name: '樱花落尽',
    role: '韩漫爱好者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20girl%20avatar%20portrait%2C%20elegant%20young%20woman%20with%20wavy%20brown%20hair%2C%20gentle%20smile%2C%20simple%20warm%20tone%20background%2C%20clean%20illustration%20style&width=120&height=120&seq=avatar-test-03&orientation=squarish',
    content: '以前找韩漫资源特别麻烦，很多网站要么收费要么不更新。韩漫吧不仅免费，分类还特别细致，找漫画太方便了！',
    rating: 5,
  },
  {
    id: 'test-4',
    name: '深海鲸鱼',
    role: '三年老用户',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20boy%20avatar%20portrait%2C%20handsome%20young%20man%20with%20short%20black%20hair%2C%20confident%20look%2C%20simple%20warm%20tone%20background%2C%20clean%20illustration%20style&width=120&height=120&seq=avatar-test-04&orientation=squarish',
    content: '从韩漫吧刚上线就在用了，亲眼看着资源越来越丰富。社区氛围也特别好，经常在评论区和其他读者交流剧情。',
    rating: 5,
  },
  {
    id: 'test-5',
    name: '星辰大海',
    role: '新晋读者',
    avatar: 'https://readdy.ai/api/search-image?query=Korean%20style%20anime%20girl%20avatar%20portrait%2C%20bright%20young%20woman%20with%20short%20cute%20hair%2C%20happy%20expression%2C%20simple%20warm%20tone%20background%2C%20clean%20illustration%20style&width=120&height=120&seq=avatar-test-05&orientation=squarish',
    content: '朋友推荐的韩漫吧，刚开始看韩漫就被吸引了。界面很清爽，推荐算法也很准，总能找到我喜欢类型的漫画。',
    rating: 5,
  },
];

export const categories = [
  { name: '奇幻冒险', slug: 'fantasy', count: 2856, icon: 'ri-sword-line' },
  { name: '恋爱言情', slug: 'romance', count: 3421, icon: 'ri-heart-line' },
  { name: '都市职场', slug: 'urban', count: 1892, icon: 'ri-building-line' },
  { name: '悬疑惊悚', slug: 'thriller', count: 1245, icon: 'ri-search-eye-line' },
  { name: '武侠动作', slug: 'martial', count: 1653, icon: 'ri-boxing-line' },
  { name: '科幻未来', slug: 'scifi', count: 987, icon: 'ri-rocket-line' },
  { name: '青春校园', slug: 'school', count: 2108, icon: 'ri-book-open-line' },
  { name: '美食治愈', slug: 'food', count: 756, icon: 'ri-restaurant-line' },
];

export const hotTags = ['热门连载', '新作上线', '高分推荐', '独家汉化', '完结经典', '本周强推'];

export const siteInfo = {
  name: '韩漫吧',
  slogan: '发现你的下一部心头好',
  description: '韩漫吧致力于推荐好看韩国漫画，提供免费漫画大全和下拉式在线阅读服务，是漫画同好分享与发现心仪作品的角落。',
  founded: 2021,
  totalUsers: '32.5万',
  totalComics: '12,860+',
  dailyActive: '8.6万',
};